/* global _satellite */
'use strict';
require('../../icons/infoHelp.svg');

/**
 * New Size Guide Changes
 */
function sizeGuideModal() {
    var TFInstanceInfo = $('#TFinstance').val();
    $('#mens-socks-size-guide .country-intl-selector option[value=AU]').remove();
    $('#mens-socks-size-guide .country-intl-selector option[value=NZ]').remove();
    $('#womens-socks-size-guide .country-intl-selector option[value=AU]').remove();
    $('#womens-socks-size-guide .country-intl-selector option[value=NZ]').remove();
    $('.intl-dropdown').selectpicker('refresh');
    var selectedOptionTitle = $('.fit-category-tab.active').find('.btn.dropdown-toggle ').attr('title');
    $('.bootstrap-select').attr({ role: 'combobox', 'aria-autocomplete': 'list', 'aria-haspopup': 'listbox', 'aria-controls': 'select-options', 'aria-label': selectedOptionTitle, 'aria-expanded': 'false', 'aria-activedescendant': '' });
    $('.dropdown-menu .selected.active').addClass('hide');
    $('.intl-dropdown .dropdown-menu').append('<div class="gradient-shadow"></div>');
    var dataStyleId = $('.trufit-container').find('.tfc-fitrec-product').data('styleid');
    var dataLocaleId = $('.trufit-container').find('.tfc-fitrec-product').data('locale');
    if ($('#sizeChartModal').hasClass('show')) {
        $('#sizeChartModal').find('.tfc-fitrec-product').attr('data-styleid', dataStyleId);
        $('#sizeChartModal').find('.tfc-fitrec-product').attr('data-locale', dataLocaleId);
    } else if (($("input[name$='enableGarmentMeasurementPDP']").val() === 'true') || ($("input[name$='enableElevatedKoreaPDP']").val() === 'true')) {
        $('.size-guide-redesign').find('.tfc-fitrec-product').attr('data-styleid', dataStyleId);
        $('.size-guide-redesign').find('.tfc-fitrec-product').attr('data-locale', dataLocaleId);
    }
    $('[data-toggle="tooltip"]').tooltip();
    var el = $('.intl-dropdown .dropdown-menu').children('.inner.show');
    if (el) {
        el.on('scroll', function () {
            if ($(el)[0].clientHeight + $(el).scrollTop() >= $(el)[0].scrollHeight) {
                $('.gradient-shadow').hide();
            } else {
                $('.gradient-shadow').show();
            }
        });
    }
    if (typeof tfcapi !== 'undefined') {
        /* eslint-disable */
        tfcapi('calculate');
        (function () {
            var a = {};
            function g(l) {
                a[l] = function (r, e, o) {
                    var w = window,
                        d = document,
                        p = [],
                        t,
                        s,
                        x;
                    w.tfcapi = t = w.tfcapi || function () {
                        t.q = t.q || [];
                        t.q.push(arguments);
                    };
                    o && !!o.deviceType && p.push('deviceType=' + o.deviceType);
                    o && o.autoCalculate === false && p.push('autoCalculate=false');
                    x = d.getElementsByTagName('script')[0];
                    s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://' + r + '-cdn' + (e === 'dev' || e === 'staging' ? '.' + e : '') + '.truefitcorp.com/fitrec/' + r + '/js/' + l + '.js?' + p.join('&');
                    x.parentNode.insertBefore(s, x);
                };
            }

            g('fitrec');
            g('tracker');

            return a;

        // Don't change anything above this line
        })().fitrec('lul', TFInstanceInfo, { autoCalculate: true });
        /* eslint-enable */
    }
    if ($('.btn.dropdown-toggle.btn-light').length > 0) {
        $('.btn.dropdown-toggle.btn-light').attr('role', 'combobox');
    }
}

/**
 * Function for Size Guide left right arrow
 */
function carouselArrows() {
    var itemSize = 120;
    var updateArrows;
    // Function to update left right arrow
    if ($('.fit-category-tab.active:not(:hidden)').find('.scroll-tab-container').length) {
        var tabList = $('.fit-category-tab.active:not(:hidden)').find('.scroll-tabs');
        var leftArrow = $('.fit-category-tab.active:not(:hidden)').find('.left-arrow');
        var rightArrow = $('.fit-category-tab.active:not(:hidden)').find('.right-arrow');
        var scrollDistance = itemSize; // Adjust the scroll distance as needed
        leftArrow.on('click', function () {
            tabList.stop(true).animate({
                scrollLeft: '-=' + scrollDistance
            }, 'slow');
        });
        rightArrow.on('click', function () {
            tabList.stop(true).animate({
                scrollLeft: '+=' + scrollDistance
            }, 'slow');
        });

        /**
         * Disable - enable arrows based on scroll position
        */
        updateArrows = function () {
            var scrollLeft = tabList.scrollLeft();
            var tabWidth = tabList.outerWidth();
            var widthRoundOff = Math.ceil(tabWidth);
            var scrollLeftRoundOff = Math.ceil(scrollLeft);
            var scrollWidth = tabList[0].scrollWidth - widthRoundOff;
            leftArrow.toggleClass('disabled', scrollLeft === 0);
            rightArrow.toggleClass('disabled', scrollLeftRoundOff >= scrollWidth);
        };

        tabList.on('scroll', function () {
            updateArrows();
        });

        updateArrows();
    }
}

/**
 * Function to update Size tabs
 */
function sizeTabsControl() {
    var listItems = $('.product-detail-content .size-btns:first-child input');
    var labelValue = $(listItems).attr('data-attr-value');
    var alphabetRegex = new RegExp('[A-Za-z]');
    var numberRegex = new RegExp('[0-9]');
    var getActiveFirstTab = $('.fit-tab-div.show:visible .fit-tab-div:first');
    var tabClickToActive = $('.fit-tab-div.show:visible');
    if (($('.fit-tab-div.show:visible').find('.garment-ul-tab-div').length && $("input[name$='enableGarmentMeasurementPDP']").val() === 'true')) {
        getActiveFirstTab = $('.fit-tab-div.show:visible').find('.fit-tab-div.show:visible').find('.fit-tab-div:first');
        tabClickToActive = $('.fit-tab-div.show:visible').find('.fit-tab-div.show:visible');
    }
    if (alphabetRegex.test(labelValue) && listItems.length) {
        if (labelValue.indexOf('/') > -1) {
            if ($('.fit-tab-div.show:visible .dual-alpha-tab').length && $('.fit-tab-div.show:visible .dual-alpha-tab:first').hasClass('active') === false) {
                getActiveFirstTab.removeClass('active show');
                tabClickToActive.find('.dual-alpha-tab:first').trigger('click');
            }
        } else if ($('.fit-tab-div.show:visible .alpha-tab').length && $('.fit-tab-div.show:visible .alpha-tab:first').hasClass('active') === false) {
            getActiveFirstTab.removeClass('active show');
            tabClickToActive.find('.alpha-tab:first').trigger('click');
        }
    } else if (numberRegex.test(labelValue)) {
        if ($('.fit-tab-div.show:visible .numeric-tab').length && $('.fit-tab-div.show:visible .numeric-tab:first').hasClass('active') === false) {
            getActiveFirstTab.removeClass('active show');
            tabClickToActive.find('.numeric-tab:first').trigger('click');
        }
    }
}

/**
 * Function to update Size tabs when product is high support
 */
function bandCupSizeTab() {
    var highSupportProduct = $("input[name$='enablesizedropdownUI']").val();
    if ($('.fit-category-tab.active.show .size-tab-fit[data-sizelabel="band/cup sizes"]').length && highSupportProduct === 'true') {
        $('.fit-category-tab.active.show .size-tab-fit').removeClass('active');
        $('.fit-category-tab.active.show .fit-tab-div').removeClass('active show');
        $('.fit-category-tab.active.show .size-tab-fit[data-sizelabel="band/cup sizes"]').trigger('click');
    }
}

$(window).on('resize', function () {
    if ($('.fit-category-tab.active:not(:hidden)').find('.scroll-tab-container').length) {
        carouselArrows();
    }

    $('.bootstrap-select').selectpicker();

    $('.bootstrap-select').on('changed.bs.select', function (e, clickedIndex) {
        var selectedOption = $(this).find('option').eq(clickedIndex).text();
        $(this).attr('aria-activedescendant', selectedOption);
    });
});
/**
 * IsAndroid to detect if the user is on an Android device
 * @return {boolean} - Compiled HTML
 */
function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

/**
 * AddAriaLabelsForAndroid to add aria-labels to all headings if on Android
 * @return {void} - Compiled HTML
 */
function addAriaLabelsForAndroid() {
    if (isAndroid()) {
        $('.switch-measurement').each(function () {
            $(this).attr('aria-live', 'assertive');
        });
    }
}

/**
 * addAriaExpandedAttribute to add aria-expanded attribute
 * @return {void} - Compiled HTML
 */
function addAriaExpandedAttribute() {
    const dropdown = $('.dropdown.bootstrap-select');
    const toggleButton = dropdown.find('[data-toggle="dropdown"]');
    toggleButton.attr('aria-expanded', 'false');
    dropdown.on('show.bs.dropdown', function () {
        toggleButton.attr('aria-expanded', 'true');
        $(this).attr('aria-expanded', 'true');
    });
    dropdown.on('hide.bs.dropdown', function () {
        toggleButton.attr('aria-expanded', 'false');
        $(this).attr('aria-expanded', 'false');
    });
}
/**
 * Function to update sizes in garment measurement image
 */
function garmentMeasurementUpdate() {
    if ($("input[name$='enableGarmentMeasurementPDP']").val() === 'true') {
        var $itemDiv = $('.garment-measuremet-new .item-tab-div.show:visible');
        $itemDiv.find('.size-data-div').addClass('d-none');
        $itemDiv.find('.item-data-div.show').find('td').removeClass('highlight-cells');
        $itemDiv.each(function () {
            var itemDataTab = $(this).find('.item-data-div.show');
            itemDataTab.each(function () {
                var $sizeRow = $(this).find('.size-table tr').first();
                var dataRows = $(this).find('.size-table tr').filter(function () {
                    return $(this).find('th').length && $(this).find('td').length;
                });
                var activeTableData = $sizeRow.find('td.active-td').index() - 1;
                dataRows.each(function () {
                    var tdActiveIndex = activeTableData;
                    var label = $(this).find('th').attr('data-size');
                    var getEachTd = $(this).find('td');
                    var value = getEachTd.eq(tdActiveIndex).text().trim();
                    getEachTd.eq(tdActiveIndex).addClass('highlight-cells');
                    if (value) {
                        $itemDiv.find('.garment-image .' + label).find('.item-data').text(value);
                        $itemDiv.find('.garment-image .' + label).removeClass('d-none');
                    } else {
                        $itemDiv.find('.garment-image .' + label).addClass('d-none');
                    }
                });
            });
        });
    }
}
/**
 * Function to update size guide data on page load
 */
function updateSizeGuideContent() {
    if ($("input[name$='enableElevatedKoreaPDP']").val() === 'true') {
        var $sizeChart = $('#sizeAndFitTab');
        var targetEl = '.size-guide-body';
        var url = $('#sizeAndFitNavTab').attr('href');
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                $sizeChart.find(targetEl).html(data);
                if ($('.size-guide-footer').length === 0) {
                    var sizeChartId = $('.size-guide-redesign').attr('id');
                    if (sizeChartId === 'womens-footwear-size-guide' || sizeChartId === 'mens-footwear-size-guide') {
                        $('.size-guide-redesign tr').removeClass('odd');
                        $('.size-guide-redesign tr').removeClass('even');
                        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':odd').addClass('even');
                        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':even').addClass('odd');
                    }
                    sizeTabsControl();
                    bandCupSizeTab();
                    garmentMeasurementUpdate();
                }
                sizeGuideModal();
                carouselArrows();
            }
        });
    }
}

$(document).ready(function () {
    updateSizeGuideContent();
    addAriaLabelsForAndroid();
    $('#mens-bottom-measure-div span.measure').attr('role', 'heading').attr('aria-level', '3');
    $('#mens-bottom-guidelines-div span.measure').attr('role', 'heading').attr('aria-level', '3');
    if ($('.size-guide-footer').length) {
        sizeGuideModal();
        addAriaExpandedAttribute();
    }
    if ($('.size-guide-footer').length && $('.fit-category-tab.active:not(:hidden)').find('.scroll-tab-container').length) {
        carouselArrows();
    }
    $('button.dropdown-toggle').click(function () {
        $('.dropdown-menu.inner.show li.selected.active').addClass('hide');
        $('.dropdown-menu.show .inner.show').scrollTop(0);
        if ($('.dropdown-toggle').attr('aria-expanded') === 'true') {
            var dropdown = $('.dropdown-menu').children('.inner').children('.dropdown-menu');
            if (dropdown[0].scrollHeight === dropdown[0].clientHeight) {
                $('.gradient-shadow').hide();
            }
        }
    });
    $(document).on('click', '.size-chart .size-chart-link, .category-list-tabs #sizeAndFitNavTab:not(.active)', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var $sizeChart;
        var targetEl;
        var url = $(this).attr('href');
        var checkEl;
        var currentElement = $(this);
        if ($("input[name$='enableElevatedKoreaPDP']").val() === 'false') {
            if ($('#sizeChartModal').length > 0) {
                $sizeChart = $('#sizeChartModal');
                targetEl = '.modal-body';
                checkEl = '.sizinginformation';
            } else {
                $sizeChart = $('#genericSizeChartModal');
                targetEl = '.tab-content';
                checkEl = '.sizechart';
            }
        } else {
            $sizeChart = $('#sizeAndFitTab');
            targetEl = '.size-guide-body';
            checkEl = '.sizinginformation';
        }

        if ($sizeChart.length > 0 && $sizeChart.find(checkEl).length > 0) {
            $sizeChart.modal('show');
        } else {
            $.ajax({
                url: url,
                type: 'get',
                success: function (data) {
                    if (data.content != null) {
                        $sizeChart.find(targetEl).html(data.content);
                        $sizeChart.modal('show');
                    } else {
                        $sizeChart.find(targetEl).html(data);
                        if ($(currentElement).hasClass('size-chart-link') && ($("input[name$='enableElevatedKoreaPDP']").val() === 'true')) {
                            var scrollTo = $('#sizeAndFitTab');
                            // var scrollToPosition = $(window).width() < 1024 ? 50 : 100;
                            var elementTop = $(scrollTo).offset().top - 100;
                            // $(scrollTo).trigger('click');
                            $('.category-list-tabs .nav-link').removeClass('active');
                            $('#sizeAndFitNavTab').addClass('active');
                            window.scrollTo({
                                top: elementTop,
                                behavior: 'smooth'
                            });
                        } else if (!$(currentElement).hasClass('size-chart-nav')) {
                            $sizeChart.modal('show');
                        }
                        if ($('.size-guide-footer').length === 0) {
                            var sizeChartId = $('.size-guide-redesign').attr('id');
                            if (sizeChartId === 'womens-footwear-size-guide' || sizeChartId === 'mens-footwear-size-guide') {
                                $('.size-guide-redesign tr').removeClass('odd');
                                $('.size-guide-redesign tr').removeClass('even');
                                $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':odd').addClass('even');
                                $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':even').addClass('odd');
                            }
                            garmentMeasurementUpdate();
                            sizeTabsControl();
                            bandCupSizeTab();
                        }
                        sizeGuideModal();
                        carouselArrows();
                        addAriaExpandedAttribute();
                    }
                }
            });
        }
    });

    $('#mensocksasia-fit .country-intl-selector option[value=AU]').remove();
    $('#mensocksasia-fit .country-intl-selector option[value=NZ]').remove();
    $('#womensocks .country-intl-selector option[value=AU]').remove();
    $('#womensocks .country-intl-selector option[value=NZ]').remove();

    $('#women-socks').on('click', function () {
        if ($('.AU').length || $('.NZ').length) {
            var womenSocksGlobalFit = $('#womensocksglobal-fit');
            var mySelection = womenSocksGlobalFit.find('.country-intl-selector');
            var targetOption = mySelection.find('option[value=UK]');
            targetOption.prop('selected', true);
            mySelection.change();
            womenSocksGlobalFit.find('li:has(a:contains(New Zealand)), li:has(a:contains(Australia))').addClass('hide');
            $('#womensocksglobal-fit .filter-option').on('click', function () {
                womenSocksGlobalFit.find('li:has(a:contains(New Zealand)), li:has(a:contains(Australia))').addClass('hide');
            });
        }
        $('#womensocksglobal-fit').find('li:has(a:contains(New Zealand), a:contains(Australia))').addClass('hide');
        $('#womensocksglobal-fit').find('.filter-option').on('click', function () {
            $('#womensocksglobal-fit').find('li:has(a:contains(New Zealand)), li:has(a:contains(Australia))').addClass('hide');
        });
    });

    $('#men-socks').on('click', function () {
        if ($('.AU').length || $('.NZ').length) {
            var menSocksAsiaFit = $('#mensocksasia-fit');
            var mySelection = menSocksAsiaFit.find('.country-intl-selector');
            var targetOption = mySelection.find('option[value=UK]');
            targetOption.prop('selected', true);
            mySelection.change();
            $('#mensocksasia-fit').find('li:has(a:contains(New Zealand), a:contains(Australia))').addClass('hide');
            $('#mensocksasia-fit').find('.filter-option').on('click', function () {
                $('#mensocksasia-fit').find('li:has(a:contains(New Zealand)), li:has(a:contains(Australia))').addClass('hide');
            });
        }
        $('#mensocksasia-fit').find('li:has(a:contains(New Zealand), a:contains(Australia))').addClass('hide');
        $('#mensocksasia-fit').find('.filter-option').on('click', function () {
            $('#mensocksasia-fit').find('li:has(a:contains(New Zealand)), li:has(a:contains(Australia))').addClass('hide');
        });
    });
});

/**
 * Function for Sizeguide Redesign Modal Open
 */
function sizeGuideModalOpen() {
    $(document).on('change', '.country-intl-selector', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var parentId = $(this).closest('.fit-tab-div.active').attr('id');
        var demovalue = $(this).val();
        $('#' + parentId + ' option:not(:selected)').each(function () {
            var optionValue = $(this).val();
            $('#' + parentId + ' .show' + optionValue).addClass('d-none');
        });
        $('#' + parentId + ' .show' + demovalue).removeClass('d-none');
        if ($('#' + parentId).find('.sizeguide-tab').length) {
            var newObjectForSubHeading = {};
            $('#' + parentId + ' .sizeguide-tab').find('.scroll-tab .size-tab-fit').each(function (idx) {
                var sizeTabThis = $(this);
                var sizeTabListItems = $(sizeTabThis).attr('data-tab-names');
                var parsedJson = JSON.parse(sizeTabListItems.replace(/'/g, '"'));
                var sizeTabValue = parsedJson[demovalue];
                var changedText = parsedJson.ussizetext;
                var defaultText = parsedJson.defaultussize;
                if (sizeTabValue !== 'null') {
                    $(sizeTabThis).html(changedText + ' ' + sizeTabValue);
                    newObjectForSubHeading[idx] = changedText + ' ' + sizeTabValue;
                    $(sizeTabThis).attr('data-sizetab-id', parsedJson.sizetabid + ' ' + sizeTabValue.toLowerCase());
                } else {
                    $(sizeTabThis).html(defaultText);
                    newObjectForSubHeading[idx] = '';
                    $(sizeTabThis).attr('data-sizetab-id', $(sizeTabThis).attr('data-sizelabel'));
                }
            });
            $('#' + parentId + ' .fit-tab-div').find('.fit-subheading').each(function (idx) {
                var defaultHeading = $(this).attr('data-sizetab-heading');
                var objectValue = newObjectForSubHeading[idx];
                if (objectValue !== '') {
                    $(this).html(objectValue);
                } else {
                    $(this).html(defaultHeading);
                }
            });
        }
        $('#' + parentId).find('.fit-tab-div').each(function () {
            var sizeTableThis = $(this);
            if ($(sizeTableThis).find(' .show' + demovalue).length) {
                var newObjectForColumnHide = {};
                $(sizeTableThis).find(' .show' + demovalue + ' td').each(function (indx) {
                    var sizeTableColumnThis = $(this);
                    var columnTrimmedValue = $.trim($(sizeTableColumnThis).text());
                    if (columnTrimmedValue === '-') {
                        $(sizeTableColumnThis).addClass('d-none');
                        newObjectForColumnHide[indx] = indx;
                    } else {
                        $(sizeTableColumnThis).removeClass('d-none');
                        newObjectForColumnHide[indx] = '';
                    }
                });
                $(sizeTableThis).find('tr.table-row').each(function () {
                    var tableRowThis = $(this);
                    if (!$(tableRowThis).hasClass(' .show' + demovalue)) {
                        $(tableRowThis).find('td').each(function (index) {
                            if (newObjectForColumnHide[index] === index) {
                                $(this).addClass('d-none');
                            } else if (newObjectForColumnHide[index] === '') {
                                $(this).removeClass('d-none');
                            }
                        });
                    }
                });
            }
        });
        var selectedOptionTitle = $(this).closest('.fit-tab-div.active').find('.btn.dropdown-toggle').attr('title');
        $(this).parents('.bootstrap-select').attr('aria-label', selectedOptionTitle);
        $('.fit-tab-div.active .intl-dropdown').selectpicker('refresh');
    });
    $('.intl-dropdown').on('shown.bs.dropdown', function () {
        $('.dropdown-menu.show .inner.show').scrollTop(0);
    });
    $(document).on('shown.bs.tab', '.sizeguide-tab a[data-toggle="tab"]', function () {
        $('.size-guide-redesign tr').removeClass('odd');
        $('.size-guide-redesign tr').removeClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':odd').addClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':even').addClass('odd');
        garmentMeasurementUpdate();
        $('.intl-dropdown').selectpicker('refresh');
    });
    $(document).on('shown.bs.tab', '.categoty-fit-tab', function () {
        if ($('.size-guide-footer').length === 0) {
            sizeTabsControl();
        }
    });
    $(document).on('shown.bs.tab', '.categoty-fit-tab, .gender-tab a[data-toggle="tab"]', function () {
        if ($('.fit-category-tab.active:not(:hidden)').find('.scroll-tab-container').length) {
            carouselArrows();
        }
    });
    $(document).on('change', '.intl-dropdown', function () {
        $('.size-error-message').find('.error-message').hide();
        $('.size-guide-redesign tr').removeClass('odd');
        $('.size-guide-redesign tr').removeClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':odd').addClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':even').addClass('odd');
        $('.intl-dropdown').selectpicker('refresh');
    });
    $(document).on('change', '.measurement-div input', function (e) {
        $('.size-error-message').find('.error-message').hide();
        var parentDiv = $(this).closest('.fit-tab-div.active').attr('id');
        var isOn = e.currentTarget.checked;
        var metricToggle = isOn ? 'in' : 'cm';
        if (isOn) {
            $('#' + parentDiv + '.fit-tab-div.active .centimeter').removeClass('show');
            $('#' + parentDiv + '.fit-tab-div.active .inches').addClass('show');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-centimeters').removeClass('active');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-inches').addClass('active');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-switch').find('.visually-hidden').html('IN');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-div span.switch-measurement').attr('aria-label', 'Inches');
        } else {
            $('#' + parentDiv + '.fit-tab-div.active .inches').removeClass('show');
            $('#' + parentDiv + '.fit-tab-div.active .centimeter').addClass('show');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-centimeters').addClass('active');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-inches').removeClass('active');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-switch').find('.visually-hidden').html('CM');
            $('#' + parentDiv + '.fit-tab-div.active .measurement-div span.switch-measurement').attr('aria-label', 'Centimeter');
        }
        garmentMeasurementUpdate();
        setTimeout(function () {
            $('#' + parentDiv + '.fit-tab-div.active .measurement-switch').focus();
        }, 100);
        $('.size-guide-redesign tr').removeClass('odd');
        $('.size-guide-redesign tr').removeClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':odd').addClass('even');
        $('.size-guide-redesign tr.table-row:not(:hidden)').filter(':even').addClass('odd');
        _satellite.track('size-guide-modal', {
            modalDetails: 'metric-toggle:' + metricToggle
        });
    });

    $(document).on('keyup', '.footer-checkbox-toggle .toggle-checkbox', function (e) {
        if (document.activeElement === $('.footer-checkbox-toggle .toggle-checkbox')[0] && e.key === 9) {
            $('.footer-checkbox-toggle .switch-measurement').addClass('tabbed');
        }
        if ((document.activeElement === $('.footer-checkbox-toggle .toggle-check')[0] && e.key === 'Enter') || (document.activeElement === $('.footer-checkbox-toggle .toggle-check')[0] && e.key === 32)) {
            $('.footer-checkbox-toggle .switch-measurement').trigger('click');
        }
    });

    $(document).on('focusout', '.footer-checkbox-toggle .toggle-checkbox', function () {
        if (document.activeElement !== this) {
            $('.footer-checkbox-toggle .switch-measurement').removeClass('tabbed');
        }
    });

    $(document).on('click', '.item-tab-div.show:visible .first-table-row td', function () {
        if ($("input[name$='enableGarmentMeasurementPDP']").val() === 'true') {
            var clickIndex = $(this).index() - 1;
            $('.item-tab-div.show:visible .first-table-row').find('td').removeClass('active-td');
            $(this).addClass('active-td');
            $('.item-tab-div.show:visible table:hidden').find('.first-table-row td').eq(clickIndex).addClass('active-td');
            garmentMeasurementUpdate();
        }
    });

    // $(document).on('mouseenter', '.item-tab-div.show:visible .table-row:not(.first-table-row) td', function () {
    //     if ($("input[name$='enableGarmentMeasurementPDP']").val() === 'true') {
    //         var tdIndex = $(this).index();
    //         var $tableRow = $(this).closest('tr');
    //         var columnIndex = $tableRow.find('.highlight-cells').index();
    //         $tableRow.find('th, td').each(function (indx) {
    //             if (indx <= columnIndex && tdIndex <= columnIndex) {
    //                 $(this).addClass('trow-highlight');
    //             }
    //         });
    //     }
    // });

    // $(document).on('mouseleave', '.item-tab-div.show:visible .table-row:not(.first-table-row) td', function () {
    //     if ($("input[name$='enableGarmentMeasurementPDP']").val() === 'true') {
    //         $(this).closest('tr').find('th, td').removeClass('trow-highlight');
    //     }
    // });

    $(document).on('click', '.l2ctaArrow a', function () {
        var anchorLinkDecider;
        if ($(this).hasClass('return-policy-link')) {
            anchorLinkDecider = 'return-policy';
        } else if ($(this).hasClass('hemming-policy-link')) {
            anchorLinkDecider = 'repair-policy';
        }
        _satellite.track('size-guide-modal', {
            modalDetails: 'policy:' + anchorLinkDecider
        });
    });
}

// /**
//  * Function for Sticky Right Panel
//  */
// function initStickyRightPanel() {
//     var $rightPanel = $('.elevated-product-detail');
//     var $leftPanel = $('.primary-images-gallery');

//     if ($rightPanel.length === 0 || $leftPanel.length === 0) {
//         return; // No need to proceed if panels are missing
//     }

//     var rightInitialLeft = $rightPanel.offset().left;
//     var rightInitialWidth = $rightPanel.outerWidth();
// /**
//  * Function to check if the device is desktop
//  * @return {boolean} - Returns true if the device is desktop, false otherwise
//  */
//     function isDesktop() {
//         return $(window).width() >= 1024;
//     }

// /**
//  * Function to update the sticky right panel position based on scroll
//  * @return {void} - No return value, updates the CSS of the right panel
//  */
//     function updateSticky() {
//         if (!isDesktop()) {
//             $rightPanel.css({
//                 position: '',
//                 top: '',
//                 left: '',
//                 width: ''
//             });
//             return;
//         }

//         var scrollTop = $(window).scrollTop();
//         var leftTop = $leftPanel.offset().top;
//         var leftHeight = $leftPanel.outerHeight();
//         var rightHeight = $rightPanel.outerHeight();

//         var startStick = leftTop;
//         var endStick = leftTop + (leftHeight - rightHeight);

//         if (scrollTop >= startStick && scrollTop < endStick) {
//             $rightPanel.css({
//                 position: 'fixed',
//                 top: 0,
//                 left: rightInitialLeft + 'px',
//                 width: rightInitialWidth + 'px'
//             });
//         } else if (scrollTop >= endStick) {
//             $rightPanel.css({
//                 position: 'absolute',
//                 top: (leftHeight - rightHeight) + 'px',
//                 left: '60%',
//                 width: rightInitialWidth + 'px'
//             });
//         } else {
//             $rightPanel.css({
//                 position: '',
//                 top: '',
//                 left: '',
//                 width: ''
//             });
//         }
//     }

//     $(window).off('scroll.stickyPanel resize.stickyPanel'); // Remove previous handlers
//     $(window).on('scroll.stickyPanel resize.stickyPanel', function () {
//         if (isDesktop()) {
//             rightInitialLeft = $rightPanel.offset().left;
//             rightInitialWidth = $rightPanel.outerWidth();
//         }
//         updateSticky();
//     });

//     updateSticky();
// }

// $(document).ready(function () {
//     initStickyRightPanel();

//     // Call again when .show-more-imgs is clicked
//     $(document).on('click', '.show-more-imgs', function () {
//         // Assuming images load instantly or you can add delay if needed
//         initStickyRightPanel();
//     });
// });

module.exports = {
    sizeGuideModalOpen: sizeGuideModalOpen,
    updateSizeGuideContent: updateSizeGuideContent
};
